import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import theme from "./theme";
import TopBar from "./components/TopBar";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Lock from "./pages/Lock";
import Slice from "./pages/Slice";
import Proof from "./pages/Proof";
import Tools from "./pages/Tools";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <TopBar />
        <Routes>
          <Route path="/" element={<Projects />} />
          <Route path="/demo" element={<Home />} />
          <Route path="/playground" element={<Home />} />
          <Route path="/lock" element={<Lock />} />
          <Route path="/slice" element={<Slice />} />
          <Route path="/proof" element={<Proof />} />
          <Route path="/tools" element={<Tools />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
